// M8-S2 — Rol/Yetki Yönetimi (§4.7.5).

import { z } from "zod";
import { PERMISSION_KEYS } from "../types/permissions.js";

// Permissions JSONB — bilinen 33 key + custom (admin extensible)
export const PermissionsSchema = z
  .record(z.string(), z.boolean())
  .refine(
    (p) =>
      Object.keys(p).every(
        (k) => (PERMISSION_KEYS as readonly string[]).includes(k) || /^[a-z_][a-z0-9_.]*$/.test(k),
      ),
    { message: "Geçersiz permission key" },
  );

export const RoleRowSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  isSystem: z.boolean(),
  permissions: PermissionsSchema,
  userCount: z.number().int().nonnegative(),
  createdAt: z.string(),
  updatedAt: z.string(),
  updatedBy: z.string().uuid().nullable(),
});
export type RoleRow = z.infer<typeof RoleRowSchema>;

export const RolesListResponseSchema = z.object({
  roles: z.array(RoleRowSchema),
  permissionKeys: z.array(z.string()),
});
export type RolesListResponse = z.infer<typeof RolesListResponseSchema>;

export const CreateRoleRequestSchema = z.object({
  name: z.string().min(2).max(64),
  description: z.string().max(500).optional(),
  permissions: PermissionsSchema,
});
export type CreateRoleRequest = z.infer<typeof CreateRoleRequestSchema>;

export const UpdateRoleRequestSchema = z.object({
  name: z.string().min(2).max(64).optional(),
  description: z.string().max(500).optional(),
  permissions: PermissionsSchema.optional(),
});
export type UpdateRoleRequest = z.infer<typeof UpdateRoleRequestSchema>;
